// store/modules/variationCache.js
import ApiService from "../../services/ApiService";

const state = () => ({
    globalVariationCache: {}
});

const mutations = {
    /**
     * Cache the received variation.
     * Assumes the variation's unique ID is stored in variation.documents[0].id.
     */
    addVariation(state, dataset)
    {
        if (dataset.total > 0)
        {
            const variationId = dataset.documents[0].id;

            state.globalVariationCache[variationId] = dataset.documents[0].data;
        }
    }
};

const actions = {
    /**
     * Returns a variation by its ID.
     * - If cached, resolves with the cached variation.
     * - Otherwise, fetches from the API, caches the result, and then resolves.
     *
     * @param {Object} context - Vuex context.
     * @param {number} variationId - Unique identifier for the variation.
     * @returns {Promise<Object>} Variation data.
     */
    loadCachedVariation({ commit, state }, variationId)
    {
        return new Promise((resolve, reject) =>
        {
            if (!variationId || variationId <= 0)
            {
                reject(new Error("Invalid variation ID provided"));
                return;
            }

            // If the variation exists in the cache, resolve immediately.
            if (state.globalVariationCache[variationId])
            {
                resolve(state.globalVariationCache[variationId]);
            }
            else
            {
                // Otherwise, fetch it from the API.
                ApiService.get(`/rest/io/variations/${variationId}`, { resultFieldTemplate: "ListItem" })
                    .done(response =>
                    {
                        commit("addVariation", response);
                        resolve(response.documents[0].data);
                    })
                    .fail(error =>
                    {
                        reject(error);
                    });
            }

        });

    }

};

const getters = {};

export default {
    state,
    mutations,
    actions,
    getters
};
